<div class="container my-4 accessibility-page">

  <h2 class="page-title">Accessibility</h2>

  <div class="statement-box">

    <p>
      The County of Los Angeles strives to ensure that information and services
      provided through our websites is accessible, inclusive and usable for all
      people, including individuals with disabilities.
    </p>

    <p>
      We endeavor to design and maintain our websites in conformance with recognized
      accessibility standards, including:
    </p>

    <ul>
      <li>Web Content Accessibility Guidelines (WCAG) 2.1 Level AA</li>
      <li>Title II of the Americans with Disabilities Act (ADA)</li>
    </ul>

    <p>
      While we strive toward full accessibility compliance, we recognize there is still
      work to be done, and we remain dedicated to ongoing improvements.
    </p>

    <hr>

    <h3 class="section-title">Report an ADA Accessibility Issue</h3>

    <p>
      We are committed to ensuring our website is accessible to all individuals,
      including those with disabilities. If you encounter an accessibility issue
      while using our website, please report it using the form below.
    </p>

    <h4 class="section-subtitle">How to Report an Issue</h4>

    <p>To help us resolve the issue efficiently, please include the following:</p>

    <ul>
      <li><strong>Department:</strong> Specify the department related to the issue</li>
      <li><strong>Description of the Issue:</strong> Include the page or feature affected</li>
      <li><strong>Device & Browser Information:</strong> Desktop/mobile and browser used</li>
      <li><strong>Assistive Technology:</strong> Screen reader or accessibility tool used</li>
    </ul>

    <div class="email-box">
      Please contact us at:
      <a routerLink="/contact/assessor/7" class="contact-link">
      Website Support
    </a>
    </div>

  </div>

</div>